import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["categoryList", "categoryDisplay"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState } from 'react';
import { Text, View, Pressable, Platform } from 'react-native';
import { SvgUri } from 'react-native-svg';
import { ReactSVG } from 'react-svg';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { FONT_WEIGHT_REGULAR, FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
import { Image } from '../../Image/rn';
import { HotQuestionCategoryGroup2 } from './HotQuestionCategoryGroup2';
import CategoryIcon from './icon';
import { useTracking } from '../../../hooks/rn/useTracking';
import { useLocale } from '../../LocaleProvider/rn';
var CategoryDisplay;
(function (CategoryDisplay) {
  CategoryDisplay[CategoryDisplay["Control"] = 0] = "Control";
  CategoryDisplay[CategoryDisplay["CategoryOptimisation"] = 1] = "CategoryOptimisation";
  CategoryDisplay[CategoryDisplay["OtherFrequentlyAsked"] = 2] = "OtherFrequentlyAsked";
  CategoryDisplay[CategoryDisplay["SmallerTab"] = 3] = "SmallerTab";
})(CategoryDisplay || (CategoryDisplay = {}));
var iconWidth = 16;
var iconHeight = 16;
var itemLabelContainerPaddingHorizontal = 4;
export var compatibleWebSvg = function compatibleWebSvg(props) {
  var _props$icon = props.icon,
    icon = _props$icon === void 0 ? '' : _props$icon,
    width = props.width,
    height = props.height;
  if (icon) {
    if (Platform.OS === 'web') {
      // 因为 h5 的 react-native-svg 版本问题导致无法使用 SvgUri 所以这么处理 这里直接返回了 dom
      return /*#__PURE__*/React.createElement(ReactSVG, {
        src: icon,
        beforeInjection: function beforeInjection(svg) {
          svg.setAttribute('style', "width: ".concat(width, "px; height: ").concat(height, "px;"));
        }
      });
    } else {
      return /*#__PURE__*/React.createElement(SvgUri, {
        width: width,
        height: height,
        uri: icon
      });
    }
  }
  return null;
};
export var HotQuestionCategoryItem = function HotQuestionCategoryItem(props) {
  var _props$icon2 = props.icon,
    icon = _props$icon2 === void 0 ? '' : _props$icon2,
    name = props.name,
    isAdHoc = props.isAdHoc,
    onCategoryClick = props.onCategoryClick,
    adhocLabel = props.adhocLabel;
  var isAdHocIcon = isAdHoc || icon.includes('.svg') || icon.includes('.png');
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    labelTextWidth = _useState2[0],
    setLabelTextWidth = _useState2[1];
  var nameMarginRight = 4;
  var itemLabelContainerPaddingHorizontalVal = itemLabelContainerPaddingHorizontal * 2; // 因为要考虑左右都有

  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var _useLocale = useLocale(),
    region = _useLocale.region;
  var handleLabelTextLayout = function handleLabelTextLayout(event) {
    var width = event.nativeEvent.layout.width;
    setLabelTextWidth(width + itemLabelContainerPaddingHorizontalVal);
  };
  var getAdhocIcon = function getAdhocIcon() {
    if (!isAdHocIcon || !icon) {
      return null;
    }
    var isSVG = icon.split('.').pop().startsWith('svg'); // 识别资源是否是 svg

    if (isSVG) {
      return compatibleWebSvg({
        width: iconWidth,
        height: iconHeight,
        icon: icon
      });
    } else {
      return /*#__PURE__*/React.createElement(Image, {
        width: iconWidth,
        height: iconHeight,
        src: icon
      });
    }
  };
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    style: [Styles['item-container']],
    onPress: function onPress() {
      trackingClick && tracker.click(trackingClick);
      onCategoryClick === null || onCategoryClick === void 0 ? void 0 : onCategoryClick(props);
    }
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: [Styles['item-icon']]
  }, isAdHocIcon ? getAdhocIcon() : /*#__PURE__*/React.createElement(CategoryIcon, {
    icon: icon
  })), /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    ellipsizeMode: "tail",
    style: [Styles['item-name'], {
      marginRight: isAdHoc ? labelTextWidth + nameMarginRight : 0
    }, region === 'th' && {
      lineHeight: 18
    }]
  }, name), isAdHoc ? /*#__PURE__*/React.createElement(View, {
    style: [Styles['item-label-container']]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [Styles['item-label']],
    onLayout: handleLabelTextLayout
  }, adhocLabel || 'Hot')) : null);
};
export var HotQuestionCategory = function HotQuestionCategory(props) {
  var _props$categoryList = props.categoryList,
    categoryList = _props$categoryList === void 0 ? [] : _props$categoryList,
    categoryDisplay = props.categoryDisplay,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (categoryDisplay === CategoryDisplay.SmallerTab) {
    return /*#__PURE__*/React.createElement(HotQuestionCategoryGroup2, props);
  } else {
    return /*#__PURE__*/React.createElement(View, {
      style: [Styles.container]
    }, categoryList.map(function (item, idx) {
      return /*#__PURE__*/React.createElement(HotQuestionCategoryItem, _extends({}, item, otherProps, {
        key: idx
      }));
    }));
  }
};
var itemContainerMarginLeft = 4;
var ITEM_CONTAINER_MAX_WIDTH = Platform.select({
  android: {
    maxWidth: '100%'
  },
  ios: {
    maxWidth: '100%'
  },
  web: {
    maxWidth: "calc(100% - ".concat(itemContainerMarginLeft, "px)")
  }
});
var containerPadding = Platform.select({
  android: {
    padding: 11,
    paddingBottom: 3,
    paddingLeft: 7
  },
  ios: {
    padding: 11,
    paddingBottom: 3,
    paddingLeft: 7
  },
  web: {
    padding: 12,
    paddingBottom: 4,
    paddingLeft: 8
  }
});
var itemContainerPadding = Platform.select({
  android: {
    paddingHorizontal: 11,
    paddingVertical: 7
  },
  ios: {
    paddingHorizontal: 11,
    paddingVertical: 7
  },
  web: {
    paddingHorizontal: 12,
    paddingVertical: 8
  }
});
var Styles = CustomStyleSheet({
  container: _objectSpread(_objectSpread({}, containerPadding), {}, {
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 12,
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden'
  }),
  'item-container': _objectSpread(_objectSpread(_objectSpread({}, ITEM_CONTAINER_MAX_WIDTH), itemContainerPadding), {}, {
    backgroundColor: '#F7F7F7',
    borderRadius: 43,
    flexDirection: 'row',
    marginBottom: 8,
    overflow: 'hidden',
    position: 'relative',
    marginLeft: itemContainerMarginLeft
  }),
  'item-icon': {
    width: iconWidth,
    height: iconHeight,
    marginRight: 4,
    position: 'absolute',
    left: 12,
    top: 8
  },
  'item-name': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 16,
    marginLeft: 20,
    color: 'rgba(0, 0, 0, 0.87)'
  }),
  'item-label-container': {
    borderRadius: 8,
    borderBottomLeftRadius: 0,
    backgroundColor: '#EE4D2D',
    height: 14,
    paddingHorizontal: itemLabelContainerPaddingHorizontal,
    justifyContent: 'center',
    position: 'absolute',
    right: 12,
    top: 8,
    width: 'auto'
  },
  'item-label': _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 9,
    color: '#FFF'
  })
});